import { render, staticRenderFns } from "./ClientResources.vue?vue&type=template&id=37c0861c&"
import script from "./ClientResources.vue?vue&type=script&lang=js&"
export * from "./ClientResources.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports